<template>
  <c-box>
    <c-heading as="h3" font-size="lg" font-weight="bold" mb="sm">
      {{ $t("productReturn.summary.title") }}
    </c-heading>
    <c-text
      v-if="formattedPlannedShippingDate()"
      :mb="{ base: 'md', md: 'xl' }"
      v-html="
        $t('productReturn.summary.textAfter.DHLDropOff', {
          date: formattedPlannedShippingDate(),
        })
      "
    />
    <c-box>
      <RMADownloadParcel
        :return-id="parcelLabelAndProFormaId"
        :return-type="returnType"
        v-chakra
        max-width="20rem"
        mb="xs"
        mr="xs"
        d="inline-block"
      />
      <RMADownloadInternationalForm
        v-if="proFormaAvailable"
        :return-id="parcelLabelAndProFormaId"
        :return-type="returnType"
        v-chakra
        max-width="20rem"
        mb="xs"
        mr="xs"
        d="inline-block"
      />
      <RMAParcelTrackingLink
        v-if="trackingCodesExist()"
        :rma-id="rmaId"
        link-type="link"
        v-chakra
        max-width="20rem"
        mb="xs"
        mr="xs"
        d="inline-block"
      />
      <RMAAddToCalendarButton
        v-if="formattedPlannedShippingDate()"
        :label="String($t('productReturn.summary.addDateToCalendar'))"
        :title="String($t('productReturn.summary.calendarEventName'))"
        :description="String($t('productReturn.summary.calendarEventDescription'))"
        :date="formattedPlannedShippingDate() ?? ''"
        iCalFileName="reminder-drop-off-dhl-parcel"
        v-chakra
        mb="xs"
        mr="xs"
        d="inline-block"
      />
      <RMADHLLocator
        :countryCode="countryCode"
        :zipCode="zipCode"
        :label="String($t('productReturn.summary.seeDropOffLocations'))"
        v-chakra
        mb="xs"
        mr="xs"
        d="inline-block"
      />
    </c-box>
  </c-box>
</template>

<script lang="ts">
import RMAAddToCalendarButton from "@/views/rma/RMAAddToCalendarButton.vue";
import RMADHLLocator from "@/views/rma/RMADHLLocator.vue";
import RMADownloadInternationalForm from "@/views/rma/RMADownloadInternationalForm.vue";
import RMADownloadParcel from "@/views/rma/RMADownloadParcel.vue";
import RMAParcelTrackingLink from "@/views/rma/RMAParcelTrackingLink.vue";
import RMAProcessSteps from "@/views/rma/RMAProcessSteps.vue";
import { CBox, CButton, CHeading, CText } from "@chakra-ui/vue";
import momentTz from "moment-timezone";
import { defineComponent, PropType } from "vue";

export default defineComponent({
  name: "RMADHLShippingInformation",
  components: {
    RMADownloadParcel,
    RMAParcelTrackingLink,
    RMADownloadInternationalForm,
    RMAProcessSteps,
    CHeading,
    CText,
    CBox,
    CButton,
    RMAAddToCalendarButton,
    RMADHLLocator,
  },
  props: {
    parcelLabelAndProFormaId: {
      type: String,
      required: true,
    },
    rmaId: {
      type: String,
      required: true,
    },
    returnType: {
      type: String,
      required: true,
    },
    countryCode: {
      type: String,
      required: true,
    },
    zipCode: {
      type: String,
      required: true,
    },
    trackingCodes: {
      type: Array as PropType<any[]>,
    },
    plannedShippingDate: {
      type: String,
    },
    proFormaAvailable: {
      type: Boolean,
    },
  },
  methods: {
    trackingCodesExist(): boolean {
      return !!this.trackingCodes?.length;
    },
    formattedPlannedShippingDate(): string | undefined {
      if (!this.plannedShippingDate) {
        return;
      }

      return momentTz(this.plannedShippingDate).format("D.M.YYYY");
    },
  },
});
</script>
